export default __webpack_public_path__ + "54465099a3d7a730fc721b625a188784.png";